import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/news/delay_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-71d6c97b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-id", "onClick"]
const _hoisted_2 = { class: "feed-item__body" }
const _hoisted_3 = { class: "feed-item__content" }
const _hoisted_4 = { class: "feed-item__title" }
const _hoisted_5 = {
  key: 0,
  class: "feed-item__stock-row"
}
const _hoisted_6 = {
  key: 0,
  class: "feed-item__top-tag"
}
const _hoisted_7 = {
  key: 1,
  class: "stock-market"
}
const _hoisted_8 = { class: "stock-name" }
const _hoisted_9 = {
  key: 2,
  src: _imports_0,
  class: "feed-item__delay-icon",
  alt: "延时"
}
const _hoisted_10 = {
  key: 1,
  class: "feed-item__stock-row"
}
const _hoisted_11 = { class: "feed-item__top-tag" }
const _hoisted_12 = {
  key: 2,
  class: "feed-item__spacer"
}
const _hoisted_13 = { class: "feed-item__footer" }
const _hoisted_14 = { class: "feed-item__source" }
const _hoisted_15 = {
  key: 0,
  class: "feed-item__col"
}
const _hoisted_16 = { class: "feed-item__time" }
const _hoisted_17 = {
  key: 0,
  class: "feed-item__thumb"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "feed-no-more"
}
const _hoisted_20 = {
  key: 2,
  class: "feed-empty"
}
const _hoisted_21 = { class: "zx-empty-text" }
const _hoisted_22 = { class: "zx-empty-text" }
const _hoisted_23 = { class: "feed-detail" }

import { ref, onMounted, onUnmounted, computed, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import infoApi from '@/api/info'
import NewsDetail from './NewsDetail.vue'
import { zh_tran, objTran } from '@/utils/lang.js'
import ws from '@/websocket/index'
import { resolveMarket, getFDMarketTag,getFDMarketRegion } from '@/websocket/quotationWebsocket'
import { getStockClass } from '@/utils/stock'
import FDEmptyData from '@/components/FDEmptyData.vue'

// ─── Props ────────────────────────────────────────────────────────────────────
interface ImgItem {
  url: string
  width: number
  height: number
  id: number
  newsId: number
  updatedTime: number
  createdTime: number
}

interface StockInfo {
  id: number
  symbol: string
  name: string
  fluctuation_range: number
  exchange: string
  market: string
  lastPrice: number | null
  isSelfSelected: number | null
  stock_list_status: string
  stock_list_status_name: string
  ei: number | null
  newsId: number
  relevance: string | null
}

// 接口实际返回的单条数据结构（字段在根层级）
interface NewsItem {
  id: number
  decryptId: string
  title: string
  introduction: string
  source: string
  bigImg: string
  imgs: ImgItem[]
  columnCode: string
  columnName: string
  createTime: number
  createTimeFormat: string
  publishTime: number
  readNum: number
  likeNum: number
  commentNum: number
  forwardCount: number
  isLike: boolean
  isMustRead: number
  isTop: number
  stockInfo: StockInfo[]
  // articleInfo 只含详情页跳转信息
  articleInfo: {
    type: string
    data: { url: string }
  }
}

// ─── 列表状态 ─────────────────────────────────────────────────────────────────

export default /*#__PURE__*/_defineComponent({
  __name: 'NewsFeed',
  props: {
    isDark: { type: Boolean },
    specialType: null,
    specialCode: null,
    apiType: null
  },
  setup(__props: any) {

const props = __props as {
  isDark: boolean
  /** specialType: 2=要闻, 3=自选全部 */
  specialType?: number
  /** specialCode: 要闻=YW, 自选=ZX, 智妍=ZY */
  specialCode?: string
  /** apiType: 'cat'(默认) | 'zhiyan' */
  apiType?: 'cat' | 'zhiyan'
}



// ─── 繁体支持 ─────────────────────────────────────────────────────────────────
const route = useRoute()
const lang = (route.query['Accept-Language'] as string) || 'zh-Hans'
const isTraditional = computed(() => lang === 'zh-Hant')

function tran(text: string): string {
  if (!text) return text
  if (isTraditional.value) return (text as any).tran()
  return text
}

onMounted(() => {
  if (isTraditional.value) {
    zh_tran('t')
  }
})

// ─── 字体大小（已移至 NewsDetail 组件）─────────────────────────────────────

// ─── 类型定义 ─────────────────────────────────────────────────────────────────
const list = ref<NewsItem[]>([])
const loading = ref(false)
const noMore = ref(false)
const page = ref(1)
const PAGE_SIZE = 20

const selectedId = ref<number | null>(null)
const selectedDecryptId = ref<string | null>(null)
const selectedCreateTimeFormat = ref<string>('')
const listRef = ref<HTMLElement | null>(null)

// ─── 请求 ─────────────────────────────────────────────────────────────────────
function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    clientType: 'h5',
    'Accept-Language': lang,
  }
}

async function fetchList(reset = false) {
  if (loading.value || (!reset && noMore.value)) return
  loading.value = true
  try {
    let res: any
    if (props.apiType === 'zhiyan') {
      // 智妍接口（GET）
      res = await infoApi.getZhiYan({
        data: {
          specialCode: props.specialCode || 'ZY',
          page: reset ? 1 : page.value,
          pageSize: PAGE_SIZE,
        },
        headers: buildHeaders(),
      })
    } else {
      // 要闻 / 自选接口（POST）
      res = await infoApi.getCatNews({
        data: {
          page: reset ? 1 : page.value,
          pageSize: PAGE_SIZE,
          specialType: props.specialType,
          specialCode: props.specialCode,
        },
        headers: buildHeaders(),
      })
    }

    // 智妍数据在 data.articles，其他在 data 数组
    let rawList: any[]
    if (props.apiType === 'zhiyan') {
      rawList = res?.data?.articles || []
    } else {
      rawList = res?.data || []
    }

    // 智妍字段映射 → 统一成 NewsItem 格式
    const items: NewsItem[] = rawList.map((item: any) => {
      if (props.apiType === 'zhiyan') {
        // imgs 可能是单个对象，统一转成数组
        const imgsArr = Array.isArray(item.imgs)
          ? item.imgs
          : item.imgs ? [item.imgs] : []
        return {
          id: item.newsId,
          decryptId: item.decryptId || '',
          title: item.title || '',
          introduction: item.introduction || '',
          source: item.columnCodeName || '',
          bigImg: item.img?.url || '',
          imgs: imgsArr,
          columnCode: item.columnCode || '',
          columnName: item.columnCodeName || '',
          createTime: item.createTime || item.publishTime || 0,
          createTimeFormat: item.createTimeFormat || '',
          publishTime: item.publishTime || 0,
          readNum: 0,
          likeNum: item.like_count || 0,
          commentNum: item.comment_count || 0,
          forwardCount: item.forward_count || 0,
          isLike: item.is_like === 1,
          isMustRead: 0,
          isTop: 0,
          stockInfo: item.stockInfoList || [],
          articleInfo: item.articleInfo || { type: '', data: { url: '' } },
        } as NewsItem
      }
      return item as NewsItem
    })

    // 繁体转换
    const converted: NewsItem[] = isTraditional.value ? objTran('t', items) : items

    if (reset) {
      const prevId = selectedId.value
      list.value = converted
      page.value = 2
      noMore.value = false
      const stillExists = converted.some((item) => item.id === prevId)
      if (!stillExists) {
        selectedId.value = null
        selectedDecryptId.value = null
      }
      // 重置时清空已订阅集合，重新订阅
      subscribedSet.clear()
      ws.websocket.safeUnsubscribeList(LIST_KEY)
    } else {
      list.value = list.value.concat(converted)
      page.value++
    }

    if (items.length < PAGE_SIZE) {
      noMore.value = true
    }

    // 订阅新加载的股票
    subscribeListStocks(converted)
  } catch (e) {
    console.error('[NewsFeed] fetchList error', e)
  } finally {
    loading.value = false
  }
}

function selectArticle(item: NewsItem) {
  selectedId.value = item.id
  selectedDecryptId.value = item.decryptId || null
  selectedCreateTimeFormat.value = item.createTimeFormat || ''
}

function openAddSelfSelect() {
  window.open('gw://funccall?funcname=OnDoCommand;param=自选.全部自选')
}

// ─── 滚动加载（向下滚动加载更久远的新闻） ────────────────────────────────────
function onScroll() {
  const el = listRef.value
  if (!el) return
  const { scrollTop, scrollHeight, clientHeight } = el
  if (scrollHeight - scrollTop - clientHeight < 80) {
    fetchList()
  }
}

// ─── 工具函数 ─────────────────────────────────────────────────────────────────

function getThumb(item: NewsItem): string {
  if (item.imgs && item.imgs.length && item.imgs[0].url) return item.imgs[0].url
  if (item.bigImg) return item.bigImg
  return ''
}

function formatTime(val: string | number | undefined): string {
  if (!val) return ''
  const d = typeof val === 'number'
    ? new Date(val > 1e10 ? val : val * 1000)
    : new Date(val)
  if (isNaN(d.getTime())) return String(val)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

function formatPct(val: number | undefined): string {
  if (val === undefined || val === null) return ''
  const sign = val >= 0 ? '+' : ''
  return `${sign}${val.toFixed(2)}%`
}

function stockClass(val: number | undefined): string {
  return getStockClass(val, preferGreenUp)
}

// 判断股票是否显示延时图标
function isDelayedStock(s: { market?: string; exchange?: string }): boolean {
  const market = (s.market || s.exchange || '').toUpperCase()
  if (!market) return false
  const region = getFDMarketRegion(market)
  if (region === 'HK' && hkDelay) return true
  if (region === 'US' && usDelay) return true
  return false
}

// ─── 行情订阅 ─────────────────────────────────────────────────────────────────
// 延时行情标识
const hkDelay = (route.query.HKDELAY as string) === '1'
const usDelay = (route.query.USDELAY as string) === '1'
// 涨跌色偏好：'1' = 绿涨红跌，其他 = 红涨绿跌
const preferGreenUp = route.query.preferGreenUptrendRedDowntrend as string | undefined

// 每个 NewsFeed 实例用唯一 key，避免多 tab 共享 cacheSub 冲突
const LIST_KEY = `newsfeed_stocks_${props.specialCode || props.specialType || 'default'}`

// 已订阅的 symbol+market 集合，用于增量追加
const subscribedSet = new Set<string>()

function resolveMarketLocal(market: string): string {
  return resolveMarket(market, hkDelay, usDelay)
}

/**
 * 从列表中提取股票，增量追加到订阅
 * 每次滚动加载新数据后调用，只把新增的股票加进去
 */
function subscribeListStocks(items: NewsItem[]) {
  const newStocks: Array<{ symbol: string; market: string }> = []

  items.forEach(item => {
    const s = item.stockInfo?.[0]
    if (!s?.symbol || !s?.market) return
    const resolvedMarket = resolveMarketLocal(s.market)
    const key = `${s.symbol}_${resolvedMarket}`
    if (!subscribedSet.has(key)) {
      subscribedSet.add(key)
      newStocks.push({ symbol: s.symbol, market: resolvedMarket })
    }
  })

  if (!newStocks.length) return

  // 取消旧订阅，重新用完整列表订阅（safeSubscribeList 用同一 key 做引用计数）
  ws.websocket.safeUnsubscribeList(LIST_KEY)

  // 重建完整股票列表
  const allStocks = Array.from(subscribedSet).map(k => {
    // key 格式：symbol_market，market 可能含下划线（如 DELAY_HKSE），只取第一个 _ 分割
    const idx = k.indexOf('_')
    return { symbol: k.slice(0, idx), market: k.slice(idx + 1) }
  })

  console.log(`[NewsFeed][${LIST_KEY}] 订阅列表股票，共 ${allStocks.length} 只:`, allStocks)
  ws.websocket.safeSubscribeList(LIST_KEY, allStocks)
}

/**
 * 处理 onHQLIST 推送，更新列表中对应股票的涨跌幅
 */
function onHqListUpdate(msg: any) {
  const dynaData: any[] = msg?.QuoteData?.DynaData || []
  console.log(`[NewsFeed][${LIST_KEY}] onHQLIST 推送数据:`, dynaData)

  dynaData.forEach((d: any) => {
    if (d.UpdownRate === undefined && d.Updown === undefined) return

    list.value.forEach(item => {
      const s = item.stockInfo?.[0]
      if (!s) return
      if (s.symbol === d.InstrumentID) {
        // UpdownRate 是小数（如 0.0274），转成百分比数值
        if (d.UpdownRate !== undefined) {
          s.fluctuation_range = parseFloat((d.UpdownRate * 100).toFixed(2))
        }
        if (d.LastPrice !== undefined) {
          s.lastPrice = d.LastPrice
        }
        console.log(`[NewsFeed][${LIST_KEY}] 更新股票 ${s.symbol} fluctuation_range=${s.fluctuation_range} lastPrice=${s.lastPrice}`)
      }
    })
  })
}

onMounted(async () => {
  // 注册行情推送监听
  ws.websocket.on('onHQLIST', onHqListUpdate)

  await fetchList(true)

  // 没有路由参数时，默认选中第一条
  const routeSelectedId = route.query.selectedId
  if (routeSelectedId) {
    const targetId = Number(routeSelectedId)
    const target = list.value.find(item => item.id === targetId)
    if (target) {
      selectArticle(target)
      await nextTick()
      const el = listRef.value?.querySelector(`[data-id="${targetId}"]`) as HTMLElement
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    } else if (list.value.length > 0) {
      selectArticle(list.value[0])
    }
  } else if (list.value.length > 0) {
    selectArticle(list.value[0])
  }
})

onUnmounted(() => {
  // 取消列表股票订阅，移除监听
  ws.websocket.safeUnsubscribeList(LIST_KEY)
  ws.websocket.removeListener('onHQLIST', onHqListUpdate)
  subscribedSet.clear()
  console.log(`[NewsFeed][${LIST_KEY}] 已取消订阅并清理`)
})

return (_ctx: any,_cache: any) => {
  const _directive_heightoverflowtitle = _resolveDirective("heightoverflowtitle")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["news-feed", __props.isDark ? 'dark' : 'light'])
  }, [
    _createElementVNode("div", {
      class: "feed-list",
      ref_key: "listRef",
      ref: listRef,
      onScroll: onScroll
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          "data-id": item.id,
          class: _normalizeClass(["feed-item", { active: selectedId.value === item.id }]),
          onClick: ($event: any) => (selectArticle(item))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(tran(item.title)), 1)
              ])), [
                [_directive_heightoverflowtitle, tran(item.title)]
              ]),
              (item.stockInfo && item.stockInfo.length>0 && (item.stockInfo[0].name || item.stockInfo[0].market))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (item.isTop === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(tran('置顶')), 1))
                      : _createCommentVNode("", true),
                    (item.stockInfo[0].market || item.stockInfo[0].exchange)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(getFDMarketTag)(item.stockInfo[0].market || item.stockInfo[0].exchange)), 1))
                      : _createCommentVNode("", true),
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(item.stockInfo[0].name) + _toDisplayString(item.stockInfo[0].symbol ? `(${item.stockInfo[0].symbol})` : ''), 1)
                    ])), [
                      [_directive_widthoverflowtitle, item.stockInfo[0].name + (item.stockInfo[0].symbol ? `(${item.stockInfo[0].symbol})` : '')]
                    ]),
                    (isDelayedStock(item.stockInfo[0]))
                      ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["stock-pct", stockClass(item.stockInfo[0].fluctuation_range)])
                    }, _toDisplayString(formatPct(item.stockInfo[0].fluctuation_range)), 3)
                  ]))
                : (item.isTop === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(tran('置顶')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(tran(item.source)), 1),
                (item.columnName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(tran(item.columnName)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_16, _toDisplayString(item.createTimeFormat || formatTime(item.createTime)), 1)
              ])
            ]),
            (getThumb(item))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("img", {
                    src: getThumb(item),
                    alt: ""
                  }, null, 8, _hoisted_18)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_1))
      }), 128)),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["feed-loading", { 'feed-loading--center': !list.value.length }])
          }, _toDisplayString(tran('加载中')) + "…", 3))
        : _createCommentVNode("", true),
      (noMore.value && list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(tran('没有更多了')), 1))
        : _createCommentVNode("", true),
      (!loading.value && !list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            (props.specialCode === 'ZX')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(FDEmptyData, { text: "" }),
                  _createElementVNode("div", _hoisted_21, [
                    _createTextVNode(_toDisplayString(tran('当前您还没有添加自选，快去')) + " ", 1),
                    _createElementVNode("span", {
                      class: "zx-empty-link",
                      onClick: openAddSelfSelect
                    }, _toDisplayString(tran('添加自选')), 1),
                    _createTextVNode(" " + _toDisplayString(tran('吧~')), 1)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(FDEmptyData, { text: "" }),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(tran('暂无数据')), 1)
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ], 544),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(NewsDetail, {
        "is-dark": __props.isDark,
        "news-id": selectedId.value,
        "news-decrypt-id": selectedDecryptId.value,
        "create-time-format": selectedCreateTimeFormat.value,
        "has-list-data": list.value.length > 0,
        "list-loading": loading.value
      }, null, 8, ["is-dark", "news-id", "news-decrypt-id", "create-time-format", "has-list-data", "list-loading"])
    ])
  ], 2))
}
}

})